import {Component, OnInit, ViewChild} from '@angular/core';
import { MatSort} from '@angular/material/sort';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import {SnackBarIconService} from '../shared/snack-bar-icon/snack-bar-icon.service';
import {Subcategory} from '../models/subcategory';
import {SubcategoryDialogComponent} from './dialogs/subcategory-dialog/subcategory-dialog.component';
import {SubcategoryService} from '../services/subcategory.service';
import {MatPaginator} from '@angular/material/paginator';
import {Subscription} from 'rxjs';
import {ConfirmComponent} from '../shared/dialogs/confirm/confirm.component';
import {AuthService} from '../services/auth.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-subcategory',
  templateUrl: './subcategory.component.html',
  styleUrls: [ './subcategory.component.scss' ],
  entryComponents: [
    SubcategoryDialogComponent,
    ConfirmComponent
  ]
})
export class SubcategoryComponent implements OnInit {

  private sub: Subscription;
  public dataSource: MatTableDataSource<any>
  public displayedColumns: string[] = [ 'icon', 'name', 'documents', 'docList', 'partner', 'hidden', 'front_desk', 'sponsor', 'annuity', 'edit' ];

  constructor (
    private _subcategoryService: SubcategoryService,
    private dialog: MatDialog,
    private snackBar: SnackBarIconService,
    private _authService: AuthService,
    private router: Router
  ) {

    if (!this._authService.isAdmin) {
      this.router.navigate([ 'home' ]);
    }

  }

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  ngOnInit () {
    this.loadCategory()
  }

  ngOnDestroy () {
    if (this.sub)
      this.sub.unsubscribe();
  }

  loadCategory () {

    let tempArray: any[] = []

    this.sub = this._subcategoryService.select()
      .subscribe((result) => {

        let tempArray: any[] = []
        let array: any[] = []

        result.forEach((item) => {
          let entity = new Subcategory();
          entity.id = item.payload.doc.id;
          entity.name = item.payload.doc.data().name;
          entity.hidden = item.payload.doc.data().hidden;
          entity.partner = item.payload.doc.data().partner;
          entity.sponsor = item.payload.doc.data().sponsor ? true : false;
          entity.front_desk = item.payload.doc.data().front_desk ? true : false;
          entity.annuity = item.payload.doc.data().annuity ? true : false;

          entity.documents = item.payload.doc.data().documents;
          entity.documents_en = item.payload.doc.data().documents_en;

          entity.docList = item.payload.doc.data().docList;

          array.push(entity)

          if (item.payload.doc.data().sponsor) {
            tempArray.push({
              'id': item.payload.doc.id,
              'name': item.payload.doc.data().name
            })
          }


        })

        /*
        let array = result.map(item => {
          let entity = new Subcategory();
          entity.id = item.payload.doc.id;
          entity.name = item.payload.doc.data().name;
          entity.hidden = item.payload.doc.data().hidden;
          entity.partner = item.payload.doc.data().partner;
          entity.sponsor = item.payload.doc.data().sponsor ? true : false;
          entity.front_desk = item.payload.doc.data().front_desk ? true : false;
          entity.documents = item.payload.doc.data().documents;
          entity.documents_en = item.payload.doc.data().documents_en;
          return entity;
        });
        */

        //console.log("tempArray: " + JSON.stringify(tempArray))

        setTimeout(() => {
          this.dataSource = new MatTableDataSource(array);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        });


      },
        (error) => {
          console.log(JSON.stringify(error))
          this.snackBar.openSnackBar("Acesso negado", '', 'error');
        })

  }

  applyFilter (filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  openDialog (entity) {

    let data: Subcategory = new Subcategory();

    if (entity) {
      data = entity;
    }

    this.dialog.open(SubcategoryDialogComponent, {
      width: '800px',
      height: '700px',
      panelClass: 'custom-dialog-container',
      data: data
    });
  }

}
